import { BankOutlined } from '@ant-design/icons';
import {
  CommonComputedWidgetPreview,
  Datatype,
  IWidgetType,
  WidgetCategory,
  WidgetMainType,
  getSimpleWidgetReference,
  tran,
} from '@framework/engine';
import { BurdenWidgetComponent } from './BurdenWidgetComponent';
import { BurdenWidgetConfigComponent } from './BurdenWidgetConfigComponent';
import { BurdenWidgetConfigSchema } from './BurdenWidgetConfigSchema';
import { IBurdenWidget, WidgetTypeBurden } from './IBurdenWidget';
import { createBurdenWidgetFormSchema } from './createBurdenWidgetFormSchema';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    Burden = 'burden',
  }
}

/**
 * Widget per la gestione del calcolo dell'onere
 */
export const BurdenWidgetType: IWidgetType<IBurdenWidget> = {
  type: WidgetTypeBurden,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  name: 'Onere',
  icon: <BankOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Number),
  getSiblingReferences: () => [],
  formComponent: BurdenWidgetComponent,
  createFormSchema: createBurdenWidgetFormSchema,
  previewComponent: CommonComputedWidgetPreview,
  configValidator: BurdenWidgetConfigSchema,
  configComponent: BurdenWidgetConfigComponent,
  configOptions: {},
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    placeholder: tran.string(),
    rules: tran.rules(),
  }),
  rules: [],
};
